<template>
  <fwa-record type="My Staff FWA Record"></fwa-record>
</template>
  
<script>
import FwaRecord from "./FwaRecord.vue";
export default {
  components: {
    FwaRecord,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Fwa/MyStaffFwaRecord.vue